<template>
  <!-- begin::Scrolltop -->
  <button
    id="kt_scrolltop"
    ref="kt_scrolltop"
    type="button"
    class="scrolltop"
    aria-label="Kembali ke atas"
    title="Kembali ke atas"
  >
    <svg class="scrolltop__icon" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M5 15.5 12 8l7 7.5" />
    </svg>
  </button>
  <!-- end::Scrolltop -->
</template>

<script>
import KTLayoutScrolltop from "@/assets/js/layout/extended/scrolltop.js";

export default {
  name: "KTScrollTop",
  mounted() {
    // Init Scrolltop
    KTLayoutScrolltop.init(this.$refs["kt_scrolltop"]);
  }
};
</script>
